export default __webpack_public_path__ + "static/media/evo-white.bcc159af.svg";